import {
  BATCH_PROBLEMS,
  TOTAL_BATCH_PROBLEM_COUNT,
  PATTERN_STATS,
  PROBLEMS,
  TEMPLATE_LIBRARY,
  TOTAL_PROBLEM_COUNT,
  slugify,
} from './problemTopics';

const byId = new Map(PROBLEMS.map((problem) => [problem.id, problem]));

export const getProblemById = (id) => byId.get(id);

export {
  BATCH_PROBLEMS,
  TOTAL_BATCH_PROBLEM_COUNT,
  PATTERN_STATS,
  PROBLEMS,
  TEMPLATE_LIBRARY,
  TOTAL_PROBLEM_COUNT,
  slugify,
};
